import React from "react"
import * as S from "./blog-hero.styles"
// import LogoHeart from "../../assets/link-heart.svg"
import LogoLinkedin from "../../assets/link-linkedin.svg"
import LogoMail from "../../assets/link-mail.svg"
import dayjs from "dayjs"

const BlogHero = ({ featuredBlog }) => {
  const dateObj = dayjs(featuredBlog.date)

  const { name, firstName, lastName } = featuredBlog?.author?.node

  return (
    <S.Section>
      <S.Wrapper maxWidth="lg">
        <S.ImageWrapper img="https://cms.titleone.aftershock.agency/wp-content/uploads/2024/01/pattern.svg">
          <S.CustomBgImage
            alt={featuredBlog.title}
            img={featuredBlog.featuredImage?.node}
          />
        </S.ImageWrapper>
        <S.TextWrapper>
          <S.DateAuthorWrapper>
            <S.Date>{dateObj.format("MMMM D, YYYY")}</S.Date>
            <S.Square>&#9632;</S.Square>
            <S.Author>
              By {firstName && lastName ? `${firstName} ${lastName}` : name}
            </S.Author>
          </S.DateAuthorWrapper>

          <S.Title>{featuredBlog.title}</S.Title>

          <S.SocialMediaIconsWrapper>
            {/* <S.SocialMediaIcon href="/" target="_blank">
              <LogoHeart />
            </S.SocialMediaIcon> */}
            <S.SocialMediaIcon
              href={`https://www.linkedin.com/sharing/share-offsite/?url=${
                process.env.GATSBY_WEBSITE_URL + "/blog/" + featuredBlog.slug
              }`}
              target="_blank"
            >
              <LogoLinkedin />
            </S.SocialMediaIcon>
            <S.SocialMediaIcon
              href={`mailto:?subject=${encodeURIComponent(
                "Check out this blog!",
              )}&body=${encodeURIComponent(
                `Hi! I would like to share this blog with you: ${
                  process.env.GATSBY_WEBSITE_URL + "/blog/" + featuredBlog.slug
                }`,
              )}`}
              target="_blank"
            >
              <LogoMail />
            </S.SocialMediaIcon>
          </S.SocialMediaIconsWrapper>
        </S.TextWrapper>
      </S.Wrapper>
    </S.Section>
  )
}
export default BlogHero
